<template>
    <div>
        <el-container direction="vertical">
            <div class="divClass">
                <div>
                    <el-form label-width="100px" :inline="true" style="margin-top: 20px;margin-left: 20px;"
                        v-loading="formLoading" label-position="left">

                        <el-form-item label="患者姓名" style="margin-left: 50px;">
                            <el-input v-model="listQuery.name" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="登记号">
                            <el-input v-model="listQuery.recordNo" placeholder="请输入登记号"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式">
                            <el-input v-model="listQuery.phone" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item label="管理标签" style="margin-left: 50px;">
                            <el-select v-model="listQuery.tag">
                                <el-option v-for="x in manageTagsList" :key="x.value" :label="x.label"
                                    :value="x.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="复查到期时间" style="margin-left: 25px;">
                            <el-date-picker v-model="valueData1" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="纳入管理日期" style="margin-left: 25px;" label-width="200">
                            <el-date-picker v-model="valueData2" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="复查状态" style="margin-left: 25px;">
                            <el-select v-model="listQuery.reviewFlag" placeholder="全部" clearable style="width: 130px;">
                                <el-option label="需复查" :value="1" />
                                <el-option label="不复查" :value="0" />
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" style="margin-left: 50px" @click="submitForm">查询</el-button>
                            <el-button @click="resetSetting">重置</el-button>
                            <el-button @click="reportExportToExcel">导出</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <el-table ref="multipleTable" v-loading="listLoading" :data="list" border fit highlight-current-row
                    style="width: 100%; margin-left: 0px;">
                    <el-table-column align="center" label="姓名" width="80px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="120px" align="center" label="登记号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.recordNo || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="性别" width="60px">
                        <template slot-scope="scope">
                            <span>{{ getGender(scope.row.gender) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="年龄" width="60px">
                        <template slot-scope="scope">
                            <span>{{ getAge(scope.row.birthday) }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="联系方式" width="110px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.phone }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="纳入管理日期" width="140px">
                        <template>
                            <span>{{ '-' }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="管理标签" width="120px">
                        <template slot-scope="scope">
                            <span>{{ scope.row?.diseaseGroup || '' }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="管理状态" width="100px">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.manageStatus === 'TERMINATED'" type="danger" size="mini">已终止</el-tag>
                            <el-tag v-else-if="scope.row.manageStatus === 'ACTIVE'" type="success" size="mini">管理中</el-tag>
                            <span v-else>{{ scope.row.manageStatus || '-' }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="随诊建议" width="120px">
                        <template slot-scope="scope">
                            <span>{{ scope.row?.record?.lungcanerGuide || '' }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column width="150px" align="center" label="复查到期时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.reviewDueDate || '-' }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column width="100px" align="center" label="复查状态">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.reviewFlag === 0" type="warning" size="mini">不复查</el-tag>
                            <el-tag v-else-if="scope.row.reviewFlag === 1" type="success" size="mini">需复查</el-tag>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>

                    <el-table-column min-width="150px" align="center" label="手术情况">
                        <template slot-scope="scope">
                            <span>{{scope.row?.inhosLungInfo?.map(x => x.surgery_name_main)?.join(', ') || '-'
                            }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column width="120px" align="center" label="病理类型">
                        <template slot-scope="scope">
                            <span>{{scope.row?.inhosLungInfo?.map(x => x.diag_name_pathology)?.join(', ') || '-'
                            }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" align="center" label="操作" width="220px">
                        <template slot-scope="scope">
                            <el-button style="margin-left: 0px; align-self: center" type="text"
                                @click="patientsDetail(scope.row)">
                                查看档案
                            </el-button>

                            <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="bringUnderManagement(scope.row)">
                                修改方案
                            </el-button>

                            <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="handleTerminateManagement(scope.row)">
                                终止管理
                            </el-button>

                            <!-- <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="patientIntegrationDetail(scope.row)">
                                一体化方案
                            </el-button> -->

                            <!-- <el-button style="margin-left: 5px; align-self: center" type="text"
                                @click="handleTransferManagement(scope.row)">
                                转移管理
                            </el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <floating-scrollbar table-ref="multipleTable"></floating-scrollbar>
                <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize" @pagination="turnToPage" style="margin-top: 0px;" />

                <!-- <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail> -->

                <patientLungDetail v-if="patientDetailVisible" ref="PatientDetailRef" />
                <!-- 修改方案 -->
                <managementPlanModal v-if="managementPlanModalVisible" ref="managementPlanRef"
                    @upDataList="submitForm" />

                <!-- 转移管理 -->
                <transfer-management v-if="transferManagementVisible" ref="transferManagementRef"></transfer-management>

                <!-- 一体化方案详情 -->
                <patient-integration-detail v-if="patientIntegrationDetailVisible" ref="patientIntegrationDetailRef" />

                <!-- 终止管理弹窗 -->
                <el-dialog title="终止管理" :visible.sync="terminateDialogVisible" width="500px"
                    :close-on-click-modal="false" @close="terminateDialogClosed">
                    <el-form :model="terminateForm" :rules="terminateRules" ref="terminateFormRef">
                        <el-form-item label="患者姓名" label-width="100px">
                            <span>{{ terminatePatientName }}</span>
                        </el-form-item>
                        <el-form-item label="终止原因" prop="reason" label-width="100px">
                            <el-input type="textarea" v-model="terminateForm.reason" :rows="4"
                                placeholder="请输入终止管理的原因" maxlength="500" show-word-limit>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer">
                        <el-button @click="terminateDialogVisible = false">取消</el-button>
                        <el-button type="danger" @click="confirmTerminate" :loading="terminateLoading">确认终止</el-button>
                    </span>
                </el-dialog>

            </div>
        </el-container>
    </div>
</template>
<script>
import {
    getSearchList,
    getSearchListByLabel,
    turnToPageList,
    turnToPageListByLabel,
    delPatientList,
    getlistEhrDepts,
    getByIdPatientDetail,
    addContactList,
    reportToExcel,
    getSolrSearchList,
    turnToSolrPageList,
    getSysDicList,
    getUserInfos,
    addIntegrateManage,
} from "@/api/health/Patients";
import { postPatientFollowupGroupsByGroupName, postTerminateManagement } from "@/api/health/Lung";
import Pagination from "@/components/Pagination";
import patientDetail from "@/views/patient/patientDetail";
import patientRecord from "@/views/patient/patientRecord";
import transferManagement from "@/views/patient/transferManagement";
import SelectTree from "@/components/selectTree";
import { Loading } from "element-ui";
import moment from "moment";
import patientIntegrationDetail from "../integrationManagement/patientIntegrationDetail.vue";
import managementPlanModal from "../../components/managementPlanModal/index.vue";
import patientLungDetail from "../patientLung/patientLungDetail.vue";
import floatingScrollbar from "../../components/floatingScrollbar/index.vue";

export default {
    components: {
        Pagination,
        patientDetail,
        patientRecord,
        SelectTree,
        transferManagement,
        patientIntegrationDetail,
        managementPlanModal,
        patientLungDetail,
        floatingScrollbar
    },
    data() {
        return {
            screenWidth: 1000,
            patientDetailVisible: false,
            transferManagementVisible: false,
            editPatientVisible: false,
            managementPlanVisible: false,
            patientIntegrationDetailVisible: false,
            managementPlanModalVisible: false,
            data: [],
            list: null,
            total: 0,
            listLoading: false,
            formLoading: false,
            valueData: null,
            valueData1: null,
            valueData2: null,
            loadingOptions: {
                text: "正在导出...",
                background: "rgba(0, 0, 0, 0.6)",
            },
            doctorDept: null,
            doctorName: null,
            listQuery: {
                visitTimeStart: null,
                visitTimeEnd: null,
                recordNo: null,
                pageNum: 0,
                pageSize: 10,
                labels: [],
                planExists: "true",
                tag: null,
                reviewFlag: null,
                name: null
            },
            manageTagsList: [],
            userInfos: {},
            patientHavePhone: '全部',
            riskLevelDanger: false,
            dangerLevelChencked: false,
            diseaseCategorySelected: null,
            inLabelsSelected: [],
            multipleSelection: [],
            doctorManageRules: null,
            managerHospitalList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            diseaseCategoryOptionsDanger: [
                {
                    value: '{"label": "diabet_danger","filter":"and","operator":"in"}',
                    label: "糖尿病",
                },
                {
                    value: '{"label": "hyper_danger","filter":"and","operator":"in"}',
                    label: "高血压",
                },
                {
                    value: '{"label": "hyperuricemia_danger","filter":"and","operator":"in"}',
                    label: "高尿酸",
                },
                {
                    value: '{"label": "bloodfat_danger","filter":"and","operator":"in"}',
                    label: "高血脂",
                },
                {
                    value: '{"label": "overweight","filter":"and","operator":"in"}',
                    label: "高体重",
                },
                {
                    value: '{"label": "copd","filter":"and","operator":"in"}',
                    label: "慢阻肺",
                },
                {
                    value: '{"label": "lungcancer_danger","filter":"and","operator":"in"}',
                    label: "肺癌管理",
                }
            ],
            diseaseCategoryOptions: [
                {
                    value: '{"label": "diabet","filter":"and","operator":"in"}',
                    label: "糖尿病",
                },
                {
                    value: '{"label": "hyper","filter":"and","operator":"in"}',
                    label: "高血压",
                },
                {
                    value: '{"label": "hyperuricemia","filter":"and","operator":"in"}',
                    label: "高尿酸",
                },
                {
                    value: '{"label": "bloodfat","filter":"and","operator":"in"}',
                    label: "高血脂",
                },
                {
                    value: '{"label": "overweight","filter":"and","operator":"in"}',
                    label: "高体重",
                },
                {
                    value: '{"label": "copd","filter":"and","operator":"in"}',
                    label: "慢阻肺",
                },
                {
                    value: '{"label": "lungcancer","filter":"and","operator":"in"}',
                    label: "肺癌管理",
                }
            ],
            exportBody: {
                url: "/business/ehr/searchByLabel",
                headers: [
                    "姓名",
                    "性别",
                    "出生年月",
                    "身份证号",
                    "最后来院时间",
                    "电话号码"
                ],
                keys: [
                    "name",
                    "gender",
                    "birthday",
                    "idcard",
                    "updateTime",
                    "phone"
                ],
                body: null,
            },
            sexOptions: [],
            // 终止管理
            terminateDialogVisible: false,
            terminateLoading: false,
            terminatePatientName: '',
            terminateCurrentIdcard: '',
            terminateForm: {
                reason: ''
            },
            terminateRules: {
                reason: [
                    { required: true, message: '请输入终止管理原因', trigger: 'blur' }
                ]
            },
        };
    },
    created() {
        this.screenWidth = window.__POWERED_BY_QIANKUN__ ? 1000 : 1200;
        var typeData = "性别";
        this.getSystemDictList(typeData);
        this.getDcotorDept();
        this.getManageTagsList();
        this.submitForm();
    },
    methods: {
        async getManageTagsList() {
            postPatientFollowupGroupsByGroupName({}).then(res => {
                if (res.msg === 'success') {
                    this.manageTagsList = [{ label: "全部", value: null }, ...res.data?.records?.map(x => ({
                        label: x.groupName,
                        value: x.groupName
                    })) || []];
                }
            }).catch(err => {
                console.log(err);
            })
        },
        // 纳入管理
        bringUnderManagement(row) {
            this.managementPlanModalVisible = true;
            row['isModify'] = true; // 标识当前操作为修改方案
            this.$nextTick(() => {
                this.$refs["managementPlanRef"].init(row);
            });
        },
        // 终止管理
        handleTerminateManagement(row) {
            this.terminatePatientName = row.name || '';
            this.terminateCurrentIdcard = row.idcard || '';
            this.terminateForm.reason = '';
            this.terminateDialogVisible = true;
            this.$nextTick(() => {
                this.$refs['terminateFormRef']?.clearValidate();
            });
        },
        confirmTerminate() {
            this.$refs['terminateFormRef'].validate((valid) => {
                if (!valid) return;
                this.terminateLoading = true;
                postTerminateManagement({
                    idcard: this.terminateCurrentIdcard,
                    reason: this.terminateForm.reason
                }).then(res => {
                    if (res.msg === 'success') {
                        this.$message.success('终止管理成功');
                        this.terminateDialogVisible = false;
                        this.submitForm(); // 刷新列表
                    } else {
                        this.$message.error(res.msg || '终止管理失败');
                    }
                }).catch(err => {
                    console.error(err);
                    this.$message.error('终止管理失败');
                }).finally(() => {
                    this.terminateLoading = false;
                });
            });
        },
        terminateDialogClosed() {
            this.terminateForm.reason = '';
            this.$refs['terminateFormRef']?.clearValidate();
        },
        //一体化方案
        patientIntegrationDetail(row) {
            this.patientIntegrationDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["patientIntegrationDetailRef"].init(row);
            });
        },
        //转移管理
        handleTransferManagement(row) {
            this.transferManagementVisible = true;
            this.$nextTick(() => {
                this.$refs["transferManagementRef"].init(row);
            });
        },
        // 获取医生科室名称
        getDcotorDept() {
            let params = {}
            getUserInfos(params).then((res) => {
                if ((res.msg == "success")) {
                    this.userInfos.doctorDept = res.data.deptName;
                    this.userInfos.doctorName = res.data.name;
                }
            });
        },
        //查询结果导出
        reportExportToExcel() {
            console.log(
                "查询结果导出",
                `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
            );

            let loadingInstance = Loading.service(this.loadingOptions);

            this.exportBody.url =
                "/business/ehr/searchByLabel?page=" +
                this.listQuery.pageNum +
                "&pageSize=" +
                this.listQuery.pageSize;

            this.exportBody.body = this.listQuery;
            console.log("导出表格请求body：", this.exportBody);

            reportToExcel(this.exportBody)
                .then((res) => {
                    console.log("查询表格导出====", res);

                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    let blob = new Blob([res], { type: "application/force-download" });
                    console.log(blob);
                    let fileReader = new FileReader();
                    fileReader.readAsDataURL(blob);
                    fileReader.onload = (e) => {
                        let a = document.createElement("a");
                        a.download = `标签档案${moment(new Date()).format(
                            "YYYYMMDDHHmm"
                        )}.xlsx`;
                        a.href = e.target.result;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };
                })
                .catch((error) => {
                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    console.log(error);

                    this.$message({
                        message: "导出失败",
                        type: "error",
                    });
                });
        },
        resetSetting() {
            this.listQuery = {
                visitTimeStart: null,
                visitTimeEnd: null,
                recordNo: null,
                pageNum: 0,
                pageSize: 10,
                labels: [],
                planExists: "true",
                reviewFlag: null,
                name: null
            };

            this.inLabelsSelected = [];
            this.dangerLevelChencked = false;
            this.diseaseCategorySelected = null;
            this.riskLevelDanger = false;
            this.patientHavePhone = "全部";
            this.submitForm();
        },
        getSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sexOptions = records;
            }).catch(err => {
                console.log(err);
            })
        },
        getGender(gender) {
            var option = this.sexOptions.filter(v => v.value == gender)[0];
            return option.name;
        },
        setLabel0(item) {
            //糖尿病
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "diabet");
                const isIncluded2 = labels.some(dt => dt.label === "diabet_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_diabet");

                if (!this.riskLevelDanger && isIncluded1) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        setLabel1(item) {
            //高血压
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "hyper");
                const isIncluded2 = labels.some(dt => dt.label === "hyper_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_hyper");

                if (isIncluded1) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        setLabel2(item) {
            //高尿酸
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "hyperuricemia");
                const isIncluded2 = labels.some(dt => dt.label === "hyperuricemia_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_hyperuricemia");

                if (isIncluded1) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        setLabel3(item) {
            //高血脂
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "bloodfat");
                const isIncluded2 = labels.some(dt => dt.label === "bloodfat_danger");
                if (isIncluded1) {
                    return "labelRed"
                }
                if (isIncluded2) {
                    return "labelRedCircle"
                }

            } else {
                return "labelNone";
            }
        },
        setLabel4(item) {
            //高体重
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "overweight");

                if (isIncluded1) {
                    return "labelRed"
                }
            } else {
                return "labelNone";
            }
        },
        setLabel5(item) {
            //慢阻肺 肺癌管理
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded1 = labels.some(dt => dt.label === "lungcancer");
                const isIncluded2 = labels.some(dt => dt.label === "lungcancer_danger_nodule" || dt.label === "lungcancer_danger_mass" || dt.label === "lungcancer_danger_tumor");
                const isIncluded3 = labels.some(dt => dt.label === "easy_lungcancer");

                if (isIncluded1) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        // 查询健康列表
        submitForm() {

            this.listLoading = true;
            if (this.valueData != null) {
                this.listQuery.visitTimeStart = this.getParseDate(this.valueData[0], 1);
                this.listQuery.visitTimeEnd = this.getParseDate(this.valueData[1], 2);
            } else {
                this.listQuery.visitTimeStart = null;
                this.listQuery.visitTimeEnd = null;
            }

            this.listQuery.labels = [];

            console.log("按病种：", this.diseaseCategorySelected);
            if (this.diseaseCategorySelected != null) {
                var item;
                if (this.riskLevelDanger) {
                    //高危
                    item = this.diseaseCategoryOptionsDanger.find(item => item.label === this.diseaseCategorySelected);

                } else {
                    //确诊
                    item = this.diseaseCategoryOptions.find(item => item.label === this.diseaseCategorySelected);
                }
                console.log("按病种：", item);
                var itemDic = JSON.parse(item.value);
                this.listQuery.labels.push(itemDic);
            }

            // limitLabels 筛选标签，有条件后会返回单一病种数据
            this.listQuery.limitLabels = this.listQuery.labels?.map(x => x.label) || [];

            if (this.userInfos.doctorName == "韩明宏") {
                var limitLabels = ["lungcancer", "lungcancer_danger_nodule", "lungcancer_danger_mass", "lungcancer_danger_tumor"];
                this.listQuery.limitLabels = limitLabels;
            }

            if (this.patientHavePhone == "全部") {
                this.listQuery.mobileExist = null;
            } else if (this.patientHavePhone == "有") {
                this.listQuery.mobileExist = true;
            } else if (this.patientHavePhone == "无") {
                this.listQuery.mobileExist = false;
            }

            getSearchListByLabel(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list = res.data.records;
                    this.total = res.data.total;
                    this.list.forEach((item, index) => {
                        this.list[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 导航跳转查询列表页
        turnToPage() {
            this.listLoading = true;
            if (this.valueData != null) {
                this.listQuery.visitTimeStart = this.getParseDate(
                    this.valueData[0],
                    1
                );
                this.listQuery.visitTimeEnd = this.getParseDate(this.valueData[1], 2);
            } else {
                this.listQuery.visitTimeStart = null;
                this.listQuery.visitTimeEnd = null;
            }

            turnToPageListByLabel(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list = res.data.records;
                    this.total = res.data.total;
                    this.list.forEach((item, index) => {
                        this.list[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 跳转至相应病人档案详情页
        patientsDetail(row) {
            this.patientDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["PatientDetailRef"].init(row);
            });
        },
        // 日期格式转化
        getParseDate(time, type) {
            if (type == 1) {
                var newTime = new Date(time);
            } else if (type == 2) {
                var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
            }
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return (
                year +
                "-" +
                (month < 10 ? "0" + month : month) +
                "-" +
                (date < 10 ? "0" + date : date)
            );
        },
        getStandardDate(dateString) {
            if (!dateString) return null;
            const formattedDate = moment(dateString).format('YYYY-MM-DD HH:mm');
            return formattedDate;
        },
        // 身份证号加密
        formatIDcard(card) {
            if (card == null) return "";

            var str = card;
            str = str.toString().replace(/^(.{3})(?:\w+)(.{4})$/, "$1***********$2");
            return str;
        },
        // 手机号加密
        formatPhone(card) {
            if (card == null) return "";

            var str = card;
            if (str.length == 11) {
                str = str.toString().replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
                return str;
            } else if (str.length == 8) {
                str =
                    str.toString().substring(0, 2) + "****" + str.substr(str.length - 2);
                return str;
            } else {
                return str;
            }
        },
        // 计算当前年龄
        getAge(birthday) {
            if (birthday == null) return "";

            var birthdays = new Date(birthday.replace(/-/g, "/"));
            let d = new Date();
            let age =
                d.getFullYear() -
                birthdays.getFullYear() -
                (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() == birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                    ? 1
                    : 0);
            return age;
        },
    },
};
</script>
<style lang="scss" scoped>
.divClass {
    background-color: rgb(255, 255, 255);
    border: 1px solid #eee;
}

.listQuery {
    display: flex;
    flex-wrap: wrap;
    margin-top: 22px;
}

// .labelRed {
//     border-radius: 50%;
//     color: white;
//     background: red;
//     padding: 1px;
// }

.labelRed {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
}

.labelRedCircle {
    border: 1px solid red;
    background: #fff;
    color: red;
    padding: 2px;
    border-radius: 50%;
}

.labelBlue {
    border-radius: 50%;
    color: white;
    background: blue;
    padding: 3px;
}

.labelOrange {
    border-radius: 50%;
    color: white;
    background: orange;
    padding: 3px;
}

.labelGreen {
    border-radius: 50%;
    color: white;
    background: green;
    padding: 3px;
}

.labelGray {
    border-radius: 50%;
    color: white;
    background: gray;
    padding: 3px;
}

.labelPurple {
    border: 1px solid purple;
    background: purple;
    color: #fff;
    padding: 2px;
    border-radius: 50%;
}

.labelNone {
    display: none;
}

::v-deep .el-form {

    // .el-input__inner {
    //   width: 250px;
    // }
    .el-input {
        width: 200px;
    }

    .el-date-editor {
        width: 250px;
    }

    .el-form-item__label {
        // width: 90px !important;
    }

    .el-form-item:last-child .el-form-item__content {
        display: flex;
    }
}
</style>